import React from "react";
import ContentLoader from "react-content-loader";
import PropTypes from "prop-types";

export const SkeletonLoadingComponent = ({
  uniqueKey,
  viewBox = "0 0 400 475",
  height,
  width,
  webAppTheme = "dark",
  speed = 1,
  title = "",
  style,
  content,
}) => {
  const backgroundColor = webAppTheme === "dark" ? "#363C43" : "#F1F3F6";
  const foregroundColor = webAppTheme === "dark" ? "#40464D" : "#E0E4EA";
  return (
    <ContentLoader
      uniqueKey={uniqueKey}
      viewBox={viewBox}
      height={height}
      width={width}
      backgroundColor={backgroundColor}
      foregroundColor={foregroundColor}
      speed={speed}
      title={title}
      preserveAspectRatio="xMidYMid slice"
      style={style}
    >
      {content}
    </ContentLoader>
  );
};

SkeletonLoadingComponent.propTypes = {
  uniqueKey: PropTypes.string.isRequired,
  viewBox: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  webAppTheme: PropTypes.string,
  speed: PropTypes.number,
  title: PropTypes.string,
  style: PropTypes.object,
  content: PropTypes.node.isRequired,
};
